import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeConsorcio',
    pure: false
})
export class RemoveConsorcioPipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        if(filter != 1){
            return items.filter(item => item.banco.nome.indexOf("Consórcio") == -1);
        }else{
            return items;
        }
        // 
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/remove-consorcio.pipe.ts